/* Ma Robe de Chambre — header, méga-menu, menu mobile, footer, tiroir panier (Club, pochette, Garantie+) */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const desktop = window.matchMedia('(min-width: 1024px)');
  const canHover = window.matchMedia('(hover: hover)');
  const html = document.documentElement;

  /* ── header : méga-menu ── */
  function initHeader(hdr) {
    const items = [...hdr.querySelectorAll('[data-m-mega]')];
    let openItem = null;
    let openTimer = 0;

    const setOpen = (item, open) => {
      const panel = item.querySelector('.m-mega');
      const link = item.querySelector(':scope > a');
      item.classList.toggle('is-open', open);
      if (panel) panel.hidden = !open;
      if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    const closeAll = () => {
      clearTimeout(openTimer);
      items.forEach((i) => setOpen(i, false));
      openItem = null;
      hdr.classList.remove('has-mega');
    };
    const open = (item) => {
      if (openItem === item) return;
      items.forEach((i) => { if (i !== item) setOpen(i, false); });
      setOpen(item, true);
      openItem = item;
      hdr.classList.add('has-mega');
    };

    items.forEach((item) => {
      const link = item.querySelector(':scope > a');
      item.addEventListener('mouseenter', () => {
        if (!desktop.matches || !canHover.matches) return;
        clearTimeout(openTimer);
        openTimer = setTimeout(() => open(item), openItem ? 0 : 90);
      });
      item.addEventListener('focusin', () => desktop.matches && open(item));
      if (link) {
        /* écran tactile sans survol : premier appui ouvre, second suit le lien */
        link.addEventListener('click', (e) => {
          if (!desktop.matches || canHover.matches) return;
          if (openItem !== item) {
            e.preventDefault();
            open(item);
          }
        });
        link.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowDown') return;
          e.preventDefault();
          open(item);
          const first = item.querySelector('.m-mega a');
          if (first) first.focus();
        });
      }
    });
    hdr.querySelectorAll('[data-m-close-mega]').forEach((el) => el.addEventListener('mouseenter', closeAll));
    hdr.addEventListener('mouseleave', () => { if (canHover.matches) closeAll(); });
    hdr.addEventListener('focusout', (e) => { if (!hdr.contains(e.relatedTarget)) closeAll(); });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !openItem) return;
      const link = openItem.querySelector(':scope > a');
      closeAll();
      if (link) link.focus();
    });
    document.addEventListener('click', (e) => { if (openItem && !hdr.contains(e.target)) closeAll(); });
    desktop.addEventListener('change', closeAll);

    /* menu mobile */
    const drawer = document.querySelector('[data-m-drawer]');
    const opener = hdr.querySelector('[data-m-drawer-open]');
    if (drawer && opener) {
      opener.addEventListener('click', () => {
        drawer.showModal();
        opener.setAttribute('aria-expanded', 'true');
      });
      drawer.querySelectorAll('[data-m-drawer-close]').forEach((b) => b.addEventListener('click', () => drawer.close()));
      drawer.addEventListener('click', (e) => { if (e.target === drawer) drawer.close(); });
      drawer.addEventListener('close', () => opener.setAttribute('aria-expanded', 'false'));
      /* une seule rubrique ouverte à la fois */
      const cats = [...drawer.querySelectorAll('.m-dr__cat')];
      cats.forEach((d) => d.addEventListener('toggle', () => {
        if (d.open) cats.forEach((o) => { if (o !== d) o.open = false; });
      }));
      desktop.addEventListener('change', () => { if (desktop.matches && drawer.open) drawer.close(); });
    }

    /* recherche : fenêtre avec suggestions, sinon page de recherche */
    const srch = document.querySelector('[data-m-srch]');
    if (srch && typeof srch.showModal === 'function') {
      document.querySelectorAll('[data-m-search]').forEach((a) => {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          if (drawer && drawer.open) drawer.close();
          srch.showModal();
          srch.querySelector('[data-m-srch-q]').focus();
        });
      });
      initSearch(srch);
    }
  }

  /* ── suggestions de recherche (API de recherche prédictive) ── */
  function initSearch(box) {
    const input = box.querySelector('[data-m-srch-q]');
    const out = box.querySelector('[data-m-srch-res]');
    const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const money = (v) => Number(v).toFixed(2).replace('.', ',') + ' €';
    let timer = null;
    let ctrl = null;
    box.querySelector('[data-m-srch-close]').addEventListener('click', () => box.close());
    box.addEventListener('click', (e) => { if (e.target === box) box.close(); });
    const render = (q, r) => {
      const products = r.products || [];
      const links = [...(r.collections || []), ...(r.articles || []), ...(r.pages || [])];
      if (!products.length && !links.length) {
        out.innerHTML = '<p class="m-srch__none">Aucun résultat pour « ' + esc(q) + ' ».</p>';
        return;
      }
      let html = '';
      if (products.length) {
        html += '<p class="m-eyebrow">Produits</p><ul class="m-srch__p">' + products.map((p) => (
          '<li><a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '&width=120" alt="" width="60" height="75" loading="lazy">' : '<span></span>')
          + '<span><strong>' + esc(p.title) + '</strong><span>' + money(p.price) + '</span></span></a></li>'
        )).join('') + '</ul>';
      }
      if (links.length) {
        html += '<p class="m-eyebrow">Collections et conseils</p><ul class="m-srch__l">'
          + links.map((l) => '<li><a href="' + esc(l.url) + '">' + esc(l.title) + '</a></li>').join('') + '</ul>';
      }
      html += '<a class="m-link-all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&type=product">Voir tous les résultats</a>';
      out.innerHTML = html;
    };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = root + 'search/suggest.json?q=' + encodeURIComponent(q)
            + '&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
          const res = await fetch(url, { signal: ctrl.signal });
          const json = await res.json();
          render(q, (json.resources && json.resources.results) || {});
        } catch (err) {
          if (err.name !== 'AbortError') out.innerHTML = '';
        }
      }, 180);
    });
  }

  /* ── footer : colonnes ouvertes sur ordinateur, accordéons sur mobile ── */
  function initFooter() {
    const cols = [...document.querySelectorAll('[data-m-ft-col]')];
    if (!cols.length) return;
    const sync = () => cols.forEach((d) => { d.open = desktop.matches; });
    sync();
    desktop.addEventListener('change', sync);
    cols.forEach((d) => d.querySelector('summary').addEventListener('click', (e) => {
      if (desktop.matches) e.preventDefault();
    }));
  }

  /* ── onglets (produits de l'accueil) : tous les panneaux sont dans le HTML ── */
  function initTabs(root) {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        select(tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length], true);
      });
    });
  }

  /* ── texte replié (« Lire la suite ») : le texte complet est déjà dans la page ── */
  function initFold(btn) {
    const box = btn.parentElement.querySelector('[data-m-fold]');
    if (!box) return;
    const sync = () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      box.classList.toggle('is-open', open);
      btn.textContent = open ? btn.dataset.open : btn.dataset.closed;
    };
    btn.hidden = box.scrollHeight <= box.clientHeight + 4;
    btn.addEventListener('click', () => {
      btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      sync();
    });
  }

  /* ── accordéons : une seule réponse ouverte ── */
  function initAccordion(list) {
    const items = [...list.querySelectorAll(':scope > details')];
    items.forEach((d) => d.addEventListener('toggle', () => {
      if (d.open) items.forEach((o) => { if (o !== d) o.open = false; });
    }));
  }

  /* ── collection : menus de filtres et de tri, panneau mobile, « Voir plus » ── */
  function initCollection(root) {
    const pops = [...root.querySelectorAll('[data-m-pop]')];
    pops.forEach((p) => p.addEventListener('toggle', () => {
      if (p.open) pops.forEach((o) => { if (o !== p) o.open = false; });
    }));
    document.addEventListener('click', (e) => {
      pops.forEach((p) => { if (p.open && !p.contains(e.target)) p.open = false; });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') pops.forEach((p) => { p.open = false; });
    });

    const sheet = root.querySelector('[data-m-sheet]');
    const sheetBtn = root.querySelector('[data-m-sheet-open]');
    if (sheet && sheetBtn) {
      sheetBtn.addEventListener('click', () => sheet.showModal());
      sheet.querySelectorAll('[data-m-sheet-close]').forEach((b) => b.addEventListener('click', () => sheet.close()));
      sheet.addEventListener('click', (e) => { if (e.target === sheet) sheet.close(); });
    }

    const sortBtn = root.querySelector('[data-m-sort-toggle]');
    const sortList = sortBtn && document.getElementById(sortBtn.getAttribute('aria-controls'));
    if (sortBtn && sortList) {
      sortBtn.addEventListener('click', () => {
        const open = sortList.hidden;
        sortList.hidden = !open;
        sortBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* introduction : « Lire plus » déplie le texte jusqu'au premier H2 ; si tout tient déjà, elle s'affiche ouverte */
    const intro = root.querySelector('[data-m-cintro]');
    if (intro) {
      const txt = intro.querySelector('.m-cintro__txt');
      const more = intro.querySelector('[data-m-cintro-more]');
      const open = () => { intro.classList.add('is-open'); more.setAttribute('aria-expanded', 'true'); };
      if (txt.scrollHeight <= txt.clientHeight + 2) open();
      more.addEventListener('click', open);
    }

    root.querySelectorAll('[data-m-open-seo]').forEach((a) => a.addEventListener('click', () => {
      const btn = document.querySelector('#c-seo [data-m-fold-btn]');
      if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
    }));

    /* « Voir plus » : vrai lien ?page=N, les produits suivants s'ajoutent sous la grille */
    const grid = root.querySelector('[data-m-grid]');
    root.addEventListener('click', async (e) => {
      const more = e.target.closest('[data-m-more]');
      if (!more || !grid) return;
      e.preventDefault();
      if (grid.classList.contains('is-loading')) return;
      grid.classList.add('is-loading');
      try {
        const res = await fetch(more.href, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('page');
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const next = doc.querySelector('[data-m-grid]');
        const pager = doc.querySelector('[data-m-pager]');
        if (!next) throw new Error('page');
        const first = next.firstElementChild;
        grid.append(...next.children);
        const here = root.querySelector('[data-m-pager]');
        if (here && pager) here.replaceWith(pager);
        else if (here) here.remove();
        history.replaceState({}, '', more.href);
        if (first) {
          const link = first.querySelector('a[href]');
          if (link) link.focus({ preventScroll: true });
        }
      } catch (err) {
        location.href = more.href;
      } finally {
        grid.classList.remove('is-loading');
      }
    });
  }

  /* ── tiroir panier ── */
  const cart = {
    busy: false,
    lastFocus: null,
    section() { return document.getElementById('shopify-section-mrdc-cart'); },
    state() { const s = this.section(); return s && s.querySelector('[data-m-cart-state]'); },
    isOpen() { return html.classList.contains('m-cart-open'); },
    /* sur /cart, le panier est affiché dans la page : pas de tiroir à ouvrir */
    asPage: document.body.classList.contains('template-cart'),

    open() {
      const s = this.section();
      if (!s || this.asPage) return false;
      this.lastFocus = document.activeElement;
      html.classList.add('m-cart-open');
      s.querySelector('[data-m-cart]').setAttribute('aria-hidden', 'false');
      const box = s.querySelector('[role="dialog"]');
      if (box) box.focus({ preventScroll: true });
      if (window.SeoShopifyTracking && typeof window.SeoShopifyTracking.emitCartView === 'function') {
        try { window.SeoShopifyTracking.emitCartView(box, 'dialog'); } catch (e) {}
      }
      return true;
    },
    /* ouverture immédiate au clic « Ajouter au panier », contenu en attente le temps de la requête */
    openBusy() {
      const s = this.section();
      if (!s || this.asPage) return false;
      s.classList.add('is-busy');
      return this.open();
    },
    idle() {
      const s = this.section();
      if (s && !this.busy) s.classList.remove('is-busy');
    },
    /* HTML de la section renvoyé par cart/add.js ou cart/update.js (paramètre sections) : pas de requête de rendu en plus */
    paint(html) {
      const s = this.section();
      if (!s || !html) return false;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('shopify-section-mrdc-cart') || doc.body;
      const wasOpen = this.isOpen();
      s.innerHTML = fresh.innerHTML;
      if (wasOpen) s.querySelector('[data-m-cart]').setAttribute('aria-hidden', 'false');
      this.paintCount();
      this.fresh = Date.now();
      return true;
    },

    close() {
      const s = this.section();
      html.classList.remove('m-cart-open');
      if (s) s.querySelector('[data-m-cart]').setAttribute('aria-hidden', 'true');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    },

    async post(path, body) {
      const res = await fetch(root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'Panier indisponible');
      return json;
    },

    async render() {
      const s = this.section();
      if (!s) return;
      const res = await fetch(root + (this.asPage ? 'cart' : '') + '?section_id=mrdc-cart', { headers: { Accept: 'text/html' } });
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.getElementById('shopify-section-mrdc-cart');
      if (!fresh) return;
      const wasOpen = this.isOpen();
      const scroller = s.querySelector('.m-cart__body');
      const top = scroller ? scroller.scrollTop : 0;
      s.innerHTML = fresh.innerHTML;
      if (wasOpen) s.querySelector('[data-m-cart]').setAttribute('aria-hidden', 'false');
      const nextScroller = s.querySelector('.m-cart__body');
      if (nextScroller) nextScroller.scrollTop = top;
      this.paintCount();
    },

    paintCount() {
      const st = this.state();
      if (!st) return;
      const n = Number(st.dataset.count || 0);
      document.querySelectorAll('[data-m-cart-count]').forEach((el) => {
        el.textContent = String(n);
        el.classList.toggle('hide', n === 0);
      });
    },

    /* pochette offerte et tranche de Garantie+ : on aligne le panier sur ce que la section a calculé */
    async reconcile() {
      for (let round = 0; round < 3; round++) {
        const st = this.state();
        if (!st) return;
        const d = st.dataset;
        const updates = {};
        let add = null;
        const pouchKeys = (d.pouchKeys || '').split(',').filter(Boolean);
        if (d.pouchWant === '1') {
          if (!pouchKeys.length && d.pouchVariant) add = { id: Number(d.pouchVariant), quantity: 1, properties: { _mrdc: 'pochette' } };
          else if (Number(d.pouchQty) > 1) { pouchKeys.forEach((k, i) => { updates[k] = i === 0 ? 1 : 0; }); }
        } else if (pouchKeys.length) {
          pouchKeys.forEach((k) => { updates[k] = 0; });
        }
        const gKeys = (d.gKeys || '').split(',').filter(Boolean);
        if (gKeys.length) {
          if (!d.gWant) gKeys.forEach((k) => { updates[k] = 0; });
          else if (d.gHas !== d.gWant) {
            gKeys.forEach((k) => { updates[k] = 0; });
            if (!add) add = { id: Number(d.gWant), quantity: 1, properties: { _mrdc: 'garantie' } };
          } else if (gKeys.length > 1) gKeys.slice(1).forEach((k) => { updates[k] = 0; });
        }
        if (!add && !Object.keys(updates).length) return;
        if (Object.keys(updates).length) await this.post('cart/update.js', { updates });
        if (add) await this.post('cart/add.js', { items: [add] });
        await this.render();
      }
    },

    async refresh() {
      await this.render();
      await this.reconcile();
    },

    async run(task) {
      if (this.busy) return;
      this.busy = true;
      const s = this.section();
      if (s) s.classList.add('is-busy');
      try {
        await task();
        await this.refresh();
      } catch (err) {
        console.error(err);
      } finally {
        this.busy = false;
        const s2 = this.section();
        if (s2) s2.classList.remove('is-busy');
      }
    },

    async applyClub() {
      const st = this.state();
      const code = st && st.dataset.clubCode;
      if (!code) return;
      try {
        await this.post('cart/update.js', { discount: code });
      } catch (e) {
        await fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'));
      }
    },

    init() {
      const s = this.section();
      if (!s) return;
      document.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-m-cart-open]');
        if (openBtn) {
          if (this.open()) e.preventDefault();
          return;
        }
        /* « + » d'une carte à plusieurs variantes : ouvre le choix de la taille (un seul ouvert à la fois) */
        const pick = e.target.closest('[data-m-pick]');
        const closePicks = () => document.querySelectorAll('.m-card__pick:not([hidden])').forEach((box) => {
          box.hidden = true;
          box.previousElementSibling.setAttribute('aria-expanded', 'false');
        });
        if (pick) {
          const box = pick.nextElementSibling;
          const willOpen = box.hidden;
          closePicks();
          box.hidden = !willOpen;
          pick.setAttribute('aria-expanded', String(willOpen));
          return;
        }
        if (!e.target.closest('.m-card__pick')) closePicks();
        const quick = e.target.closest('[data-m-quick]');
        if (quick) {
          closePicks();
          this.run(async () => {
            const res = await this.post('cart/add.js', { items: [{ id: Number(quick.dataset.mQuick), quantity: 1 }] });
            const line0 = res && res.items && res.items[0];
            if (line0 && window.SeoShopifyTracking && typeof window.SeoShopifyTracking.handleAddToCartSuccess === 'function') {
              try { window.SeoShopifyTracking.handleAddToCartSuccess(quick, line0); } catch (err) {}
            }
          }).then(() => this.open());
          return;
        }
        if (!s.contains(e.target)) return;
        if (e.target.closest('[data-m-cart-close]')) { this.close(); return; }
        const line = e.target.closest('[data-key]');
        const qtyBtn = e.target.closest('[data-m-qty]');
        if (qtyBtn && line) {
          const quantity = Math.max(0, Number(qtyBtn.dataset.mQty));
          this.run(() => this.post('cart/change.js', { id: line.dataset.key, quantity }));
          return;
        }
        const g = e.target.closest('[data-m-garantie]');
        if (g) {
          this.run(() => this.post('cart/add.js', { items: [{ id: Number(g.dataset.mGarantie), quantity: 1, properties: { _mrdc: 'garantie' } }] }));
          return;
        }
        const addBtn = e.target.closest('[data-m-add]');
        if (addBtn) {
          this.run(async () => {
            const item = await this.post('cart/add.js', { items: [{ id: Number(addBtn.dataset.mAdd), quantity: 1 }] });
            const line0 = item && item.items && item.items[0];
            if (line0 && window.SeoShopifyTracking && typeof window.SeoShopifyTracking.handleAddToCartSuccess === 'function') {
              try { window.SeoShopifyTracking.handleAddToCartSuccess(addBtn, line0); } catch (err) {}
            }
          });
          return;
        }
        if (e.target.closest('[data-m-club]')) this.run(() => this.applyClub());
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
        if (e.key !== 'Tab' || !this.isOpen()) return;
        const box = s.querySelector('[role="dialog"]');
        const f = [...box.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
      /* ajout depuis une fiche produit (mrdc-product.js / seo-shopify-tracking.js) : on ouvre le tiroir.
         Le panier se recalcule toujours ; seul un ajout l'ouvre. */
      document.addEventListener('updateCart', (e) => {
        const added = e.detail && e.detail.lineItem;
        if (added) this.open();
        if (this.busy) return;
        /* section déjà repeinte avec la réponse de l'ajout : seule la remise d'aplomb (pochette, Garantie+) reste à faire */
        const recent = this.fresh && Date.now() - this.fresh < 4000;
        this.fresh = 0;
        Promise.resolve(recent ? this.reconcile() : this.refresh()).catch(() => {}).finally(() => this.idle());
      });
      this.paintCount();
      /* le panier peut contenir une pochette ou une Garantie+ à remettre d'aplomb (retour arrière, autre onglet) */
      if (Number((this.state() || {}).dataset?.count || 0) > 0) this.reconcile();
      window.addEventListener('pageshow', (e) => { if (e.persisted) this.refresh(); });
    },
  };
  window.MRDC = window.MRDC || {};
  window.MRDC.cart = cart;

  const boot = () => {
    document.querySelectorAll('[data-m-header]').forEach((el) => {
      if (el.dataset.mReady) return;
      el.dataset.mReady = '1';
      initHeader(el);
    });
    initFooter();
    const once = (sel, fn) => document.querySelectorAll(sel).forEach((el) => {
      if (el.dataset.mInit) return;
      el.dataset.mInit = '1';
      fn(el);
    });
    once('[data-m-tabs]', initTabs);
    once('[data-m-fold-btn]', initFold);
    once('[data-m-accordion]', initAccordion);
    once('[data-m-coll]', initCollection);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { boot(); cart.init(); });
  else { boot(); cart.init(); }
  document.addEventListener('shopify:section:load', boot);
})();
